<template>
  <PageLayout class="mini-kasko-page">
    <MiniKaskoOrder />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import MiniKaskoOrder from '../../views/miniKasko/Order.vue';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { PageLayout, MiniKaskoOrder },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-page {
  ::v-deep p,
  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3 {
    margin: 0;
  }
}
</style>
